import PrimaryButton from "components/buttons/primary-button";
import DashboardLayout from "components/layouts/dashboard-layout";
import React, { useEffect } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";
import Profile from "./components/profile";
import Password from "./components/password";
import Billings from "./components/billingsSub";
import api from "services/axiosInstance";
import Toast from "components/toast";
import { SetUser } from "services/user/setUser";

const DashboardSettings = () => {
  const GetInfo = async () => {
    try {
      const { data } = await api.get("/users/profile");
      SetUser(data);
    } catch (error) {
      Toast({ error });
    } finally {
    }
  };

  useEffect(() => {
    GetInfo();
  }, []);
  return (
    <DashboardLayout>
      <Main>
        <Profile />
        {/* <Password /> */}
        <Billings />
      </Main>
    </DashboardLayout>
  );
};

export default DashboardSettings;

const Main = styled.div`
  position: relative;
  gap: 2.5rem;
  display: flex;
  flex-direction: column;
`;
